import { render, staticRenderFns } from "./cancelAndGOTOPreviousPage.vue?vue&type=template&id=56f114dd&scoped=true&"
import script from "./cancelAndGOTOPreviousPage.vue?vue&type=script&lang=js&"
export * from "./cancelAndGOTOPreviousPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f114dd",
  null
  
)

export default component.exports